import React from "react";
import { useForm } from "react-hook-form";
import { BaseDropdown } from "@components/library/UI/BaseDropdown";

import "./TransferModal.sass";

// --- ICONS ---
import { ReactComponent as CloseIcon } from "@assets/images/icons/close-dropdown.svg";
import { ReactComponent as TransferIcon } from "@assets/images/icons/money-bill-transfer.svg";
import { ReactComponent as ChevronDown } from "@assets/images/icons/arrow-down-icon.svg";
import { ReactComponent as InfoIcon } from "@assets/images/icons/info-circle-yelow.svg";
import { ReactComponent as ArrowRightIcon } from "@assets/images/icons/arrow-right-white-icon.svg";

const TetherIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#26A17B" />
    <path
      d="M13.43 9.48V10.87C15.42 11.02 16.88 11.63 16.88 12.37C16.88 13.11 15.42 13.73 13.43 13.88V17.5H10.63V13.88C8.65 13.73 7.19 13.11 7.19 12.37C7.19 11.63 8.65 11.02 10.63 10.87V9.48H6V7H18V9.48H13.43ZM12 12.87C13.82 12.87 15.29 12.44 15.29 11.91C15.29 11.38 13.82 10.95 12 10.95C10.18 10.95 8.71 11.38 8.71 11.91C8.71 12.44 10.18 12.87 12 12.87Z"
      fill="white"
    />
  </svg>
);

// --- MOCK DATA ---
// --- MOCK DATA ---
const ACCOUNTS = [
  { id: "funding", name: "Funding", available: "0 USDT" },
  { id: "unified", name: "Unified Trading", available: "0 USDT" },
  { id: "spot", name: "Spot", available: "0 USDT" },
  { id: "futures", name: "Futures", available: "0 USDT" },
];
const COINS = [
  { id: "usdt", name: "USDT", ticker: "USDT", icon: <TetherIcon /> },
];

export const TransferModal = ({ active, setActive }) => {
  const { register, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      fromAccount: ACCOUNTS[0],
      toAccount: ACCOUNTS[1],
      coin: COINS[0],
      amount: "",
    },
  });

  const selectedFrom = watch("fromAccount");
  const selectedTo = watch("toAccount");
  const selectedCoin = watch("coin");
  // const currentAmount = watch("amount");

  const onSubmit = (data) => {
    console.log("Transfer Submitted:", data);
  };

  const handleSetAll = () => {
    setValue("amount", "0.0000", { shouldValidate: true });
  };

  if (!active) return null;

  return (
    <div className="transfer-modal-overlay" onClick={() => setActive(false)}>
      <div className="transfer-modal" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="transfer-modal__header">
          <div className="transfer-modal__title-group">
            <TransferIcon className="transfer-modal__title-icon" />
            <h3 className="transfer-modal__title">Transfer</h3>
          </div>
          <button
            className="transfer-modal__close-btn"
            onClick={() => setActive(false)}
          >
            <CloseIcon />
          </button>
        </div>

        {/* BODY */}
        <form
          className="transfer-modal__body"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* FROM / TO ACCOUNTS */}
          <div className="transfer-modal__accounts-row">
            {/* FROM */}
            <div className="transfer-modal__field">
              <label className="transfer-modal__label">From</label>
              <BaseDropdown
                hasSearch={false}
                className="transfer-modal__dropdown transfer-modal__dropdown--account"
                trigger={
                  <div className="transfer-modal__trigger">
                    {/* Access the .name property now */}
                    <span className="transfer-modal__trigger-text">
                      {selectedFrom.name}
                    </span>
                    <ChevronDown className="transfer-modal__chevron" />
                  </div>
                }
              >
                {({ closeDropdown }) => (
                  <div className="transfer-modal__menu">
                    {ACCOUNTS.map((acc) => {
                      const isActive = selectedFrom.id === acc.id;
                      return (
                        <div
                          key={acc.id}
                          className={`transfer-modal__account-item ${
                            isActive
                              ? "transfer-modal__account-item--active"
                              : ""
                          }`}
                          onClick={() => {
                            setValue("fromAccount", acc);
                            closeDropdown();
                          }}
                        >
                          <div className="transfer-modal__account-name">
                            {acc.name}
                          </div>
                          <div className="transfer-modal__account-balance">
                            Available {acc.available}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </BaseDropdown>
            </div>

            <div className="transfer-modal__arrow-wrap">
              <ArrowRightIcon />
            </div>

            {/* TO */}
            <div className="transfer-modal__field">
              <label className="transfer-modal__label">To</label>
              <BaseDropdown
                hasSearch={false}
                className="transfer-modal__dropdown transfer-modal__dropdown--account"
                trigger={
                  <div className="transfer-modal__trigger">
                    <span className="transfer-modal__trigger-text">
                      {selectedTo.name}
                    </span>
                    <ChevronDown className="transfer-modal__chevron" />
                  </div>
                }
              >
                {({ closeDropdown }) => (
                  <div className="transfer-modal__menu">
                    {ACCOUNTS.map((acc) => {
                      const isActive = selectedTo.id === acc.id;
                      return (
                        <div
                          key={acc.id}
                          className={`transfer-modal__account-item ${
                            isActive
                              ? "transfer-modal__account-item--active"
                              : ""
                          }`}
                          onClick={() => {
                            setValue("toAccount", acc);
                            closeDropdown();
                          }}
                        >
                          <div className="transfer-modal__account-name">
                            {acc.name}
                          </div>
                          <div className="transfer-modal__account-balance">
                            Available {acc.available}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </BaseDropdown>
            </div>
          </div>

          {/* COIN DROPDOWN */}
          <div className="transfer-modal__field">
            <label className="transfer-modal__label">Coin</label>
            <BaseDropdown
              hasSearch={true}
              className="transfer-modal__dropdown transfer-modal__dropdown--coin"
              trigger={
                <div className="transfer-modal__trigger">
                  <div className="transfer-modal__trigger-content">
                    {selectedCoin.icon}
                    <span className="transfer-modal__trigger-text">
                      {selectedCoin.ticker}
                    </span>
                  </div>
                  <ChevronDown className="transfer-modal__chevron" />
                </div>
              }
            >
              {({ closeDropdown, searchTerm }) => {
                const filteredCoins = COINS.filter(
                  (c) =>
                    c.name
                      .toLowerCase()
                      .includes(searchTerm?.toLowerCase() || "") ||
                    c.ticker
                      .toLowerCase()
                      .includes(searchTerm?.toLowerCase() || ""),
                );

                return (
                  <div className="transfer-modal__menu">
                    {filteredCoins.length > 0 ? (
                      filteredCoins.map((coin) => (
                        <div
                          key={coin.id}
                          className="transfer-modal__coin-item"
                          onClick={() => {
                            setValue("coin", coin);
                            closeDropdown();
                          }}
                        >
                          <div className="transfer-modal__coin-icon">
                            {coin.icon}
                          </div>
                          <div className="transfer-modal__coin-info">
                            <span className="transfer-modal__coin-name">
                              {coin.name}
                            </span>
                            <span className="transfer-modal__coin-ticker">
                              {coin.ticker}
                            </span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="transfer-modal__no-results">
                        No coins found
                      </div>
                    )}
                  </div>
                );
              }}
            </BaseDropdown>
          </div>

          {/* AMOUNT INPUT */}
          <div className="transfer-modal__field">
            <label className="transfer-modal__label">Amount</label>
            <div className="transfer-modal__amount-wrapper">
              <input
                type="number"
                className="transfer-modal__amount-input"
                {...register("amount")}
              />
              <div className="transfer-modal__amount-suffix">
                <span
                  className="transfer-modal__amount-all"
                  onClick={handleSetAll}
                >
                  All
                </span>
                <span className="transfer-modal__amount-currency">
                  {selectedCoin.ticker}
                </span>
              </div>
            </div>

            <div className="transfer-modal__amount-info">
              <span>Transferable Amount</span>
              <div className="transfer-modal__amount-balance">
                0.0000 {selectedCoin.ticker} <InfoIcon />
              </div>
            </div>
          </div>

          {/* SUBMIT BUTTON */}
          <button
            type="submit"
            className="transfer-modal__submit-btn"
            // disabled={!currentAmount}
          >
            Confirm <ArrowRightIcon />
          </button>
        </form>
      </div>
    </div>
  );
};
